/* eslint-disable react/no-multi-comp */
import React from "react"
import { graphql } from "gatsby"
import { Meta, ResourcesArticle } from "@shared"
import styles from "@pageStyles/resources.module.scss"
import { Footer, Header, PageSection } from "@components/sections"
import { CONSTANTS } from "@data"

const { COLORS, THEMES } = CONSTANTS

const mediaCoverage = "Media Coverage"
const pressRelease = "Press Release"

const AllResources = props => {
  const { data } = props
  const { allContentfulArticle: articles } = data
  const allArticles = [...articles.nodes]
  const removeMediaConverage = allArticles.filter(({ category }) => category !== mediaCoverage)
  const removePressRelease = removeMediaConverage.filter(
    ({ category }) => category !== pressRelease
  )
  const selectedArticles = removePressRelease
  return (
    <>
      <Meta />
      <Header pageColor={COLORS.FLURO} showGridLines={false} theme={THEMES.LIGHT} />
      <PageSection theme={THEMES.LIGHT}>
        <div className={styles.container}>
          <div className={styles.articles}>
            {selectedArticles.map(article => (
              <ResourcesArticle article={article} key={article.id} />
            ))}
          </div>
        </div>
      </PageSection>
      <Footer />
    </>
  )
}

export const pageQuery = graphql`
  {
    allContentfulArticle(sort: { order: DESC, fields: date }) {
      nodes {
        category
        date
        featuredArticle
        id
        slug
        source
        thumbnail {
          fluid(quality: 100, maxWidth: 1920) {
            ...GatsbyContentfulFluid_withWebp_noBase64
          }
          title
        }
        tags
        title
      }
    }
    globalMeta: contentfulPageMeta(id: { eq: "423babd8-0278-5b2e-85f6-77fb7ee55bee" }) {
      ...GlobalMetaData
    }
    pageMeta: contentfulPageMeta(contentful_id: { eq: "535TPKnQxjqzWoXAHoChnw" }) {
      ...PageMetaData
    }
  }
`

export default AllResources
